import { Roles } from "@/config/RoleOptions";
import router from '@/router';
import { defineStore } from "pinia";
import { intersection } from "lodash-es";
import API from '@/services/API';
const api = API();
const apiNoIntercept = API({ baseURL: '/api/' }, false);

export const useAuthStore = defineStore('auth', {
    state: () => ({
        authenticated: null,
    }),
    getters: {
        user(state) {
            return state.authenticated;
        },
        userId(state) {
            return state.authenticated ? state.authenticated.id : state.authenticated;
        },
        isAdmin(state){
            return state.authenticated?.roles.includes(Roles.ADMIN);
        },
        isBeta(state) {
            // the user has any of the BETA roles
            return intersection(state.authenticated?.roles, [Roles.BETA_USER, Roles.SUPER_ADMIN, Roles.BETA_OWNER]).length > 0;
        },
        isSuperAdminOrOwner(state) {
            return state.isSuperAdmin || state.isBetaOwner;
        },
        isSuperAdmin(state) {
            return intersection(state.authenticated?.roles, [Roles.SUPER_ADMIN]).length > 0;
        },
        isBetaOwner(state) {
            return intersection(state.authenticated?.roles, [Roles.BETA_OWNER]).length > 0;
        }
    },
    actions: {
        setCurrentUser(user) {
            this.authenticated = user;
        },
        async getCurrentUser(intercept = true) {
            // Already have a cached user (no need to call the API)
            if (this.authenticated) {
                return this.authenticated;
            }

            try {
                // Otherwise we get the user, intercept is to avoid infinite redirections when needed
                const response = intercept ? await api.get('users/profile') : await apiNoIntercept.get('users/profile');
                this.setCurrentUser(response.data.data);
                return response.data.data;
            } catch (error) {
                this.setCurrentUser(null);
                // Email is not verified redirecting to verification page
                if (error.response.status === 406) {
                    router.replace({ name: "VerificationNotice" });
                    return error;
                }
                
                // Load the branding data here from error.response.data
                
                return error.response.data;
            }

        },
        resetCurrentUser() {
            if (window.Intercom) {
                window.Intercom('shutdown');
            }
            this.authenticated = null;
        },
        async fetchAndSetCurrentUser() {
            const response = await api.get('users/profile');
            this.setCurrentUser(response.data.data);
        },
        currentUserHasPermission(permission) {
            return this.authenticated?.permissions.some(item => permission.includes(item.name));
        },
        currentUserHasRole(role) {
            return this.authenticated.roles.some(item => role == item.name);

        },
    },
});
export default useAuthStore;
